/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('roomTypes', {
            parent: 'masterData',
            url: '/roomTypes',
            data: {
                authorities: ['ROLE_REC_ADMINISTRATOR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/roomTypes/roomTypes.html',
                    controller: 'MDRoomTypesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
